import axios from "axios";
const baseURL = ["cdn.gtbuilder.io", "localhost"].includes(
  window.location.hostname
)
  ? "https://be-dev.swishbuilder.io"
  : "https://be-prod.swishbuilder.io";
export const axiosClient = axios.create({
  baseURL: baseURL,
  timeout: 30 * 60 * 1000,
  headers: {
    "Content-Type": "application/json",
  },
});
